<input
  #input
  type="file"
  id="{{ id }}"
  [accept]="accept"
  style="display: none"
  (change)="onSelectFile($event)"
  [multiple]="multiple"
  [disabled]="isDisabled"
  orderDesc="orderDesc"
  />

<div class="d-flex flex-wrap">
  @for (media of value; track media) {
    <div class="media-preview mx-2 mb-4">
      @if (isImage(media)) {
        <div class="image-preview">
          <img [src]="media | getSecureImgSrc | async" />
        </div>
      }
      @if (!isImage(media)) {
        <div
          class="attachment-preview d-flex flex-column align-items-center justify-content-center px-1"
          >
          <i class="feather icon-paperclip"></i>
          <span class="title ellipsis w-100 text-center" [title]="media.filename">{{
            media.filename
          }}</span>
        </div>
      }
      @if (media.url !== '') {
        <div class="mt-1" style="text-align: center">
          {{ formatDate(media.createdDate) }}
        </div>
      }
      <div class="actions">
        @if (!isDisabled && !readOnly) {
          <i
            class="icon-btn feather icon-x-circle"
            (click)="remove(media)"
            title="elimina"
            >
          </i>
        }
        @if (canUploadFiles) {
          <i
            class="icon-btn feather icon-download"
            (click)="download(media)"
            title="download"
            >
          </i>
        }
        @if (isImage(media)) {
          <i
            class="icon-btn feather icon-eye"
            (click)="zoom(media, content)"
            title="anteprima"
            >
          </i>
        }
        <!-- <i
        *ngIf="isPdf(media)"
        class="icon-btn feather icon-eye"
        title="anteprima"
        (click)="download(media, true)"
        >
      </i> -->
    </div>
  </div>
}

@if ((multiple || !value || value.length === 0) && !isDisabled && !readOnly) {
  <div
    class="media-preview mx-2 d-flex align-items-center justify-content-center"
    >
    @if (!isLoading) {
      <label
        class="cursor-pointer"
        #fileInputLabel
        for="{{ id }}"
        disabled
        >
        <i class="icon-btn feather icon-plus"> </i>
      </label>
    }
  </div>
}
</div>

<ng-template #content>
  <div class="modal-body text-center">
    @if (selectedAttachment) {
      <img
        [src]="selectedAttachment | getSecureImgSrc | async"
        />
    }
  </div>
</ng-template>
